export enum EmployeeSalaryReportType {
  table = "table",
  graphs = "graphs",
}
